import { Logo } from "@components/atoms/Logo"
import { useAppData } from "eddev/hooks"
import { Link } from "eddev/routing"
import { useEffect, useState } from "react"
import { MenuLocationEnum } from "../../types.graphql"

export function Footer() {
  const menus = useAppData((appData) => appData.menus?.nodes)
  const footerMenu = menus?.find((menu) => menu.locations?.includes(MenuLocationEnum.Footer))
  const menuItems = footerMenu?.menuItems?.nodes.filter((p) => !p.parentId)
  const legalMenu = menus?.find((menu) => menu.locations?.includes(MenuLocationEnum.Legal))

  const mobileCols = [[menuItems?.[0], menuItems?.[2]], [menuItems?.[1]]]

  // window isn't available during SSR, so resolve the hostname after mount
  const [hostname, setHostname] = useState<string | null>(null)
  useEffect(() => setHostname(window.location.hostname), [])

  const getExternalTarget = (url: string | null | undefined) => {
    if (!url || !hostname) return undefined
    const isExternal = url.startsWith("http") && !url.includes(hostname)
    return isExternal ? "_blank" : undefined
  }

  return (
    <div className="w-full bg-pavement text-stone600 p-7 gap-7 type-desktop-body-body-xs relative">
      <div className="w-grid mx-auto grid gap-8 md:gap-0 grid-cols-1 md:grid-cols-4">
        <div className="w-full">
          <Link href="/" className="text-concrete">
            <Logo className="w-logoFooterW h-logoFooterH" />
          </Link>
        </div>
        {menuItems?.map((item, ix) => (
          <div key={ix} className="hidden md:flex w-full flex-col gap-4">
            {item.childItems?.nodes.map((childItem, cx) => (
              <Link key={cx} href={childItem.url!} target={getExternalTarget(childItem.url)} className="text-link">
                {childItem.label}
              </Link>
            ))}
          </div>
        ))}
      </div>
      <div className="md:hidden mt-10 w-grid mx-auto grid gap-8 md:gap-0 grid-cols-2">
        {menuItems?.map((item, ix) => (
          <div key={ix} className="flex w-full flex-col gap-4">
            {item.childItems?.nodes.map((childItem, cx) => (
              <Link key={cx} href={childItem.url!} target={getExternalTarget(childItem.url)} className="text-link">
                {childItem.label}
              </Link>
            ))}
          </div>
        ))}
      </div>
      <div className="w-grid mx-auto flex justify-between items-start pt-7 mt-7 border-t border-t-stone600">
        <div className="flex gap-6">
          {legalMenu?.menuItems?.nodes.map((item, ix) => (
            <Link key={ix} href={item.url!} target={getExternalTarget(item.url)} className="text-link">
              {item.label}
            </Link>
          ))}
        </div>
        <div className="flex gap-6">{/* <Link href="/">Site Credits</Link> */}</div>
      </div>
    </div>
  )
}
